/* eslint-disable */
import { getUploadLivraisonErrorMessage } from "../../../utils/uploadLivraisonError";
import { doc, updateDoc, getDoc, setDoc } from "firebase/firestore";
import axios from "axios";
import Swal from "sweetalert2";
import { db } from "../../../firebase";
import { datat } from "./data";
import { datatZr } from "../../../utils/data_livraison/zrExpressV2/dataZr";
import { CommuneZimou } from "./communeZimou";
import { citeMorooco } from "./citeMorooco";
import { states_lby } from "./statesLibye";
import { territoriesData } from "../../../utils/data_livraison/zrExpressV2/territories";
import data_maystro from "../../../utils/data_livraison/data_maystro.json";
import data_ecotrack from "../../../utils/data_livraison/data_ecotrack.json";
import data_ecom from "../../../utils/data_livraison/data_ecom.json";
import data_guepex from "../../../utils/data_livraison/data_guepex.json";
import wilayaMylerzzz from "./wilayaMylerz.json";
import getNoestCommuneFrenchName from "./noest/noestCommunes";
import {
  createOsenOrder,
  getOsenProvinces,
} from "../../../api/delivery/osenApi";
import { auth } from "../../../firebase";
import data_ecotrack_stopdesks from "../../../utils/data_livraison/data_ecotrack_stopdesks.json";

// Performance: build lookup maps once to avoid repeated datat.find/filter calls
const wilayaNameToCode = new Map();
const wilayaNameToAscii = new Map();
const communeNameToAscii = new Map();
const communeNameToWilayaCode = new Map();
const communeNameToDatat = new Map();

(function buildDatatMaps() {
  try {
    for (const item of datat) {
      if (item?.wilaya_name) {
        if (!wilayaNameToCode.has(item.wilaya_name)) {
          wilayaNameToCode.set(item.wilaya_name, item.wilaya_code);
        }
        if (
          item.wilaya_name_ascii &&
          !wilayaNameToAscii.has(item.wilaya_name)
        ) {
          wilayaNameToAscii.set(item.wilaya_name, item.wilaya_name_ascii);
        }
      }
      if (item?.commune_name) {
        if (item.commune_name_ascii)
          communeNameToAscii.set(item.commune_name, item.commune_name_ascii);
        if (item.wilaya_code)
          communeNameToWilayaCode.set(item.commune_name, item.wilaya_code);
        communeNameToDatat.set(item.commune_name, item);
      }
    }
  } catch (e) {
    // ignore map build errors
  }
})();

function getWilayaCode(name) {
  const normalizedName = String(name || "")
    .trim()
    .replace("إن صالح", "عين صالح");
  return wilayaNameToCode.get(normalizedName) ?? "";
}
function getWilayaAscii(name) {
  const normalizedName = String(name || "")
    .trim()
    .replace("إن صالح", "عين صالح");
  return wilayaNameToAscii.get(normalizedName) ?? name ?? "";
}
function getCommuneAscii(name) {
  return communeNameToAscii.get(name) ?? name ?? "";
}
function getCommuneWilayaCode(name) {
  return communeNameToWilayaCode.get(name) ?? "";
}
function getDatatCommune(name) {
  return communeNameToDatat.get(name) ?? null;
}

function getNoestApiMessage(error) {
  const responseData = error?.response?.data;
  if (typeof responseData === "string") return responseData;

  return (
    responseData?.message ||
    Object.values(responseData?.errors || {})[0] ||
    error?.message ||
    "Une erreur est survenue"
  );
}

const url1 = "https://backend.foorweb.store/api/UploadLivraison";
// Prevent duplicate simultaneous requests for the same Noest order
const pendingNoestOrders = new Set();

function buildProductDetails(data) {
  let productDetails = "";

  if (Array.isArray(data.products) && data.products.length > 0) {
    data.products.forEach((product, index) => {
      let productName = product.name;
      const quantity = product.quantity;

      if (data.stockDelivery === true) {
        productDetails = product.sku;
        return;
      }
      if (data.products.length === 1) {
        productName = product.name;
      } else if (productName.length > 10) {
        productName = productName.substring(0, 15) + "...";
      }

      const color = product.options?.color || "";
      const size = product.options?.size || "";
      const offer = product.options?.offer
        ? `العرض: ${product?.options?.offer}`
        : "";

      const details = `(${productName} × ${quantity} ${color && `+ ${color}`} ${size && `+ ${size}`} ${offer && `+ ${offer}`})`;

      productDetails += details;

      if (index < data.products.length - 1) {
        productDetails += " + ";
      }
    });
  }

  return productDetails.replace(
    /[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F1E0}-\u{1F1FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]|[\u{1F900}-\u{1F9FF}]|[\u{1F018}-\u{1F270}]|[\u{238C}-\u{2454}]|[\u{20D0}-\u{20FF}]|[\u{FE00}-\u{FE0F}]|[\u{1F200}-\u{1F251}]/gu,
    "",
  );
}

function getCombinedOrderNote(data) {
  return [data?.note, data?.commercantNote]
    .map((note) => String(note || "").trim())
    .filter(Boolean)
    .join("\n");
}

function escapeHtml(value) {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

function getZrErrorMessages(errorResponse, fallbackMessage) {
  const validationErrors = errorResponse?.error?.errors;

  if (Array.isArray(validationErrors) && validationErrors.length > 0) {
    return validationErrors
      .map((validationError) => validationError?.description)
      .filter(Boolean);
  }

  return [
    errorResponse?.error?.detail ||
      errorResponse?.message ||
      fallbackMessage ||
      "حدث خطأ غير معروف",
  ];
}

function isValidGuid(value) {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
    String(value || ""),
  );
}

async function sendToNoestWithDesk({
  data,
  productDetails,
  adresse,
  selectedDeskCode,
  store,
  deliveryCompanyStatus,
  onSuccess,
}) {
  // Guard: don't re-send if already marked delivered or has tracking
  if (data?.deleveryStatus === "4" || data?.tracking) {
    return { success: false, message: "already_sent" };
  }

  // Guard: avoid duplicate simultaneous requests for the same order id
  if (pendingNoestOrders.has(data.id)) {
    return { success: false, message: "request_in_progress" };
  }

  pendingNoestOrders.add(data.id);
  try {
    const wilayaId = getWilayaCode(data.state);
    const communeName =
      getNoestCommuneFrenchName(data.commune, wilayaId) ||
      getCommuneAscii(data.commune);

    const response = await axios.post(
      "https://app.noest-dz.com/api/public/create/order",
      {
        user_guid: store.Userguid,
        api_token: store.ApitokenNord,
        type_id: 1,
        stop_desk: 1,
        produit: productDetails,
        client: data.name,
        phone: data.phone,
        quantite: `${data.qty}`,
        adresse,
        wilaya_id: wilayaId,
        commune: communeName,
        montant: data.total,
        NoteClient: getCombinedOrderNote(data),
        Remboursement: 0,
        poids: "0",
      },
    );

    const tracking = response?.data?.tracking;
    await updateDoc(doc(db, "orders", data.id), {
      deleveryStatus: "4",
      DC: deliveryCompanyStatus,
      tracking,
      selectedDesk: selectedDeskCode,
    });

    if (typeof onSuccess === "function") {
      try {
        onSuccess({
          ...data,
          deleveryStatus: "4",
          DC: deliveryCompanyStatus,
          tracking,
          selectedDesk: selectedDeskCode,
        });
      } catch (e) {
        console.error("onSuccess callback error:", e);
      }
    }
  } catch (error) {
    return {
      success: false,
      error: getNoestApiMessage(error),
    };
  } finally {
    pendingNoestOrders.delete(data.id);
  }
}

async function sendToNoestNormal({
  data,
  productDetails,
  adresse,
  store,
  deliveryCompanyStatus,
  onSuccess,
}) {
  const wilayaId = getWilayaCode(data.state);
  const communeName =
    getNoestCommuneFrenchName(data.commune, wilayaId) ||
    getCommuneAscii(data.commune);

  const orderData = {
    user_guid: `${store.Userguid}`,
    api_token: `${store.ApitokenNord}`,
    type_id: 1,
    stop_desk: 0,
    produit: `${productDetails}`,
    client: data.name,
    phone: data.phone,
    quantite: `${data.qty}`,
    adresse,
    wilaya_id: wilayaId,
    commune: communeName,
    montant: data.total,
    NoteClient: getCombinedOrderNote(data),
    Remboursement: 0,
    poids: "0",
  };

  try {
    const response = await axios.post(
      "https://app.noest-dz.com/api/public/create/order",
      orderData,
    );
    const tracking = response?.data?.tracking;

    await updateDoc(doc(db, "orders", data.id), {
      deleveryStatus: "4",
      DC: deliveryCompanyStatus,
      tracking,
    });

    if (typeof onSuccess === "function") {
      try {
        onSuccess({
          ...data,
          deleveryStatus: "4",
          DC: deliveryCompanyStatus,
          tracking,
        });
      } catch (e) {
        console.error("onSuccess callback error:", e);
      }
    }

    return { success: true, tracking };
  } catch (error) {
    return { success: false, error: getNoestApiMessage(error) };
  }
}

async function sendToYalidineWithDesk({
  data,
  productDetails,
  adresse,
  selectedDeskCode,
  store,
  deliveryCompanyStatus,
  onSuccess,
}) {
  const postData = {
    keyword: "yalidine",
    data: [
      {
        order_id: "MyFirstOrder",
        center_code: selectedDeskCode,
        firstname: ".",
        familyname: data.name,
        contact_phone: data.phone,
        address: adresse,
        to_commune_name: getCommuneAscii(data.commune),
        to_wilaya_name: getWilayaAscii(data.state),
        product_list: `${productDetails}`,
        price: Number(data.total),
        do_insurance: false,
        declared_value: Number(data.total),
        length: 10,
        width: 10,
        height: 10,
        weight: 1,
        freeshipping: true,
        is_stopdesk: data.stopdeskDelivery ? data.stopdeskDelivery : false,
        stopdesk_id: 0,
        has_exchange: false,
        product_to_collect: null,
      },
    ],
  };

  const response = await axios.post(url1, postData, {
    headers: {
      "yalidine-id": store.Yalidineid,
      "yalidine-token": store.Yalidinetoken,
      "Content-Type": "application/json",
    },
  });

  const tracking = response.data?.data?.MyFirstOrder.tracking;
  await updateDoc(doc(db, "orders", data.id), {
    deleveryStatus: "4",
    tracking,
    DC: deliveryCompanyStatus,
  });

  if (typeof onSuccess === "function") {
    try {
      onSuccess({
        ...data,
        deleveryStatus: "4",
        tracking,
        DC: deliveryCompanyStatus,
      });
    } catch (e) {
      console.error("onSuccess callback error:", e);
    }
  }

  return { success: true, tracking };
}
 
async function sendToYalidineNormal({
  data,
  productDetails,
  adresse,
  store,
  deliveryCompanyStatus,
  onSuccess,
}) {
  const postData = {
    keyword: "yalidine",
    data: [
      {
        order_id: "MyFirstOrder",
        firstname: ".",
        familyname: data.name,
        contact_phone: data.phone,
        address: adresse,
        to_commune_name: getCommuneAscii(data.commune),
        to_wilaya_name: getWilayaAscii(data.state),
        product_list: `${productDetails}`,
        price: Number(data.total),
        do_insurance: false,
        declared_value: Number(data.total),
        length: 10,
        width: 10,
        height: 10,
        weight: 1,
        freeshipping: true,
        is_stopdesk: data.stopdeskDelivery ? data.stopdeskDelivery : false,
        stopdesk_id: 0,
        has_exchange: false,
        product_to_collect: null,
      },
    ],
  };

  const response = await axios.post(url1, postData, {
    headers: {
      "yalidine-id": store.Yalidineid,
      "yalidine-token": store.Yalidinetoken,
      "Content-Type": "application/json",
    },
  });

  const tracking = response.data?.data?.MyFirstOrder.tracking;
  await updateDoc(doc(db, "orders", data.id), {
    deleveryStatus: "4",
    tracking,
    DC: deliveryCompanyStatus,
  });

  if (typeof onSuccess === "function") {
    try {
      onSuccess({
        ...data,
        deleveryStatus: "4",
        tracking,
        DC: deliveryCompanyStatus,
      });
    } catch (e) {
      console.error("onSuccess callback error:", e);
    }
  }

  return { success: true, tracking };
}

function formatPhoneNumber(phone) {
  if (!phone) return "";
  let num = phone.replace(/[\s-]/g, "");
  if (!num.startsWith("+213")) {
    if (num.startsWith("0")) {
      num = "+213" + num.slice(1);
    } else {
      num = "+213" + num;
    }
  }
  return num;
}

function isStopdeskEnabled(data) {
  const rawValue =
    data?.stopdeskDelivery ??
    data?.stopdesk ??
    data?.stop_desk ??
    data?.is_stopdesk;

  if (typeof rawValue === "boolean") return rawValue;
  if (typeof rawValue === "number") return rawValue === 1;
  if (typeof rawValue === "string") {
    const normalized = rawValue.trim().toLowerCase();
    return normalized === "1" || normalized === "true";
  }

  return false;
}

function normalizeText(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ");
}

function getEcotrackStopdesksForWilaya(wilayaCode, stateArabic) {
  const desks = Array.isArray(data_ecotrack_stopdesks?.other_desks)
    ? data_ecotrack_stopdesks.other_desks
    : [];

  const code = String(Number(wilayaCode) || wilayaCode || "").trim();
  const wilayaFr = normalizeText(getWilayaAscii(stateArabic));

  return desks.filter((desk) => {
    const name = String(desk?.name || "").trim();
    if (code && (name.startsWith(`${code} `) || name.startsWith(`${code} -`))) {
      return true;
    }
    return wilayaFr && normalizeText(desk?.wilaya) === wilayaFr;
  });
}

function resolveEcotrackCommune({
  isStopdesk,
  orderCommuneAr,
  wilayaCode,
  selectedDesk,
}) {
  if (isStopdesk && selectedDesk) {
    const deskCommune = String(selectedDesk.commune || "").trim();
    if (deskCommune) {
      const match = data_ecotrack.find(
        (c) =>
          String(c.wilaya_id) === String(Number(wilayaCode)) &&
          (normalizeText(c.nom) === normalizeText(deskCommune) ||
            normalizeText(c.nom_ar) === normalizeText(deskCommune)),
      );
      return match?.nom || deskCommune;
    }
  }

  const byAr = data_ecotrack.find(
    (c) =>
      c.nom_ar === orderCommuneAr &&
      String(c.wilaya_id) === String(Number(wilayaCode)),
  );
  if (byAr?.nom) return byAr.nom;

  const byFr = data_ecotrack.find(
    (c) =>
      normalizeText(c.nom) === normalizeText(orderCommuneAr) &&
      String(c.wilaya_id) === String(Number(wilayaCode)),
  );
  return byFr?.nom || getCommuneAscii(orderCommuneAr) || orderCommuneAr || "";
}

const ecotrackErrorMessageMap = {
  "Unauthenticated.": "unauthenticated",
  "Le champ nom client est obligatoire.": "missing_client_name",
  "Le numéro de téléphone est invalide": "invalid_phone",
  "Le champ téléphone est obligatoire.": "missing_phone",
  "Le champ adresse est obligatoire.": "missing_address",
  "Le champ commune est obligatoire.": "missing_commune",
  "Commune mal écrite, ou désactivée.": "invalid_commune",
  "Le champ code wilaya est obligatoire. (and 1 more error)": "missing_wilaya",
  "La valeur de code wilaya doit être comprise entre 1 et 100. (and 2 more errors)":
    "invalid_wilaya",
  "Le champ montant est obligatoire.": "missing_amount",
};

function getEcotrackTranslatedError(message, t) {
  const translationKey = ecotrackErrorMessageMap[message] || "default";
  return t(
    `orders.datatable_templating_demo.ecotrack_errors.${translationKey}`,
  );
}

export async function changeShip({
  data,
  status,
  store,
  products,
  setErrorMessage,
  t,
  noestSelectedDeskCode,
  yalidineSelectedDeskCode,
  setNoestPendingData,
  setNoestPendingResolve,
  setNoestPendingReject,
  setNoestModalOpen,
  setYalidinePendingData,
  setYalidinePendingResolve,
  setYalidinePendingReject,
  setYalidineModalOpen,
  selectedDeskCode,
  ecomdeliverySelectedDeskCode,
  setEcomdeliveryPendingData,
  setEcomdeliveryPendingResolve,
  setEcomdeliveryPendingReject,
  setEcomdeliveryModalOpen,
  ecomdeliveryV2SelectedDeskCode,
  setEcomdeliveryV2PendingData,
  setEcomdeliveryV2PendingResolve,
  setEcomdeliveryV2PendingReject,
  setEcomdeliveryV2ModalOpen,
  ecotrackSelectedDeskName,
  setEcotrackPendingData,
  setEcotrackPendingDesks,
  setEcotrackPendingResolve,
  setEcotrackPendingReject,
  setEcotrackModalOpen,
  zrExpressSelectedHub,
  setZrExpressPendingData,
  setZrExpressPendingResolve,
  setZrExpressPendingReject,
  setZrExpressModalOpen,
  onSuccess,
}) {
  const adresse = data.address ? data.address : ".";
  const productDetails = buildProductDetails(data);
  const totalNumber = Number(data.total);

  if (status === "1") {
    const stopdesk =
      data.stopdeskDelivery != null && data.stopdeskDelivery ? 2 : 1;

    let total = data.total;
    if (data.deleveryPrice) {
      total += data.deleveryPrice;
    }

    const maystroProducts = [];
    if (data.products) {
      for (const key in data.products) {
        const product = data.products[key];
        const sku = products.find((p) => p.name === product.name)?.sku;
        maystroProducts.push({
          product_id: sku,
          logistical_description: String(product.name || ""),
          quantity: Number(product.quantity) || 1,
          is_exchange:
            data.exchangeDelivery != null && data.exchangeDelivery
              ? true
              : false,
        });
      }
    }

    const WilayaMaystro = Number(getWilayaCode(data.state));

    const dataMaystro = data_maystro.find(
      (d) => d.name_ar === data.commune && d.wilaya === WilayaMaystro,
    );

    const communeMaystro = dataMaystro?.id;

    const order = {
      commune: communeMaystro,
      customer_name: data.name || "",
      customer_phone: data.phone || "",
      customer_phone2: data.phone2 || null,
      destination_text: null,
      products: maystroProducts,
      total_price: String(total),
      express: false,
      pickup_point: null,
      external_order_id: null,
      note_to_driver: getCombinedOrderNote(data),
      delivery_type: stopdesk,
      source: 1,
      use_points: false,
      wilaya: Number(WilayaMaystro) || null,
      is_exchange:
        data.exchangeDelivery != null && data.exchangeDelivery ? true : false,
      old_order: null,
    };

    try {
      const response = await axios.post(
        "https://backend.foorweb.store/api/v1/maystro/addOrder",
        {
          token: store.Maystro,
          order,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const result = response.data?.data;

      const tracking =
        result?.display_id ||
        result?.data?.display_id ||
        result?.[0]?.tracking ||
        result?.tracking;

      const maystroId = result?.id || result?.data?.id || result?.[0]?.id;

      if (tracking) {
        await updateDoc(doc(db, "orders", data.id), {
          deleveryStatus: "4",
          tracking,
          DC: status,
          MaystroId: maystroId,
        });

        if (typeof onSuccess === "function") {
          try {
            onSuccess({
              ...data,
              deleveryStatus: "4",
              tracking,
              DC: status,
              MaystroId: maystroId,
            });
          } catch (e) {
            console.error("onSuccess callback error:", e);
          }
        }
      } else {
        const message =
          response.data?.error || response.data?.details?.detail || "erreur !";
        setErrorMessage(message);
      }
    } catch (error) {
      setErrorMessage(
        getUploadLivraisonErrorMessage(error) || (error.response?.data?.details?.duplicated ||
          error.response?.data?.details?.total_price ||
          error.response?.data?.details?.detail ||
          error.response?.data?.details?.customer_name ||
          error.response?.data?.details?.customer_phone ||
          error.response?.data?.error ||
          "Une erreur est survenue"),
      );
    }
  } else if (status === "2") {
    const headers = {
      "zr-express-token": `${store.Zrexpress}`,
      "zr-express-cle": `${store.ZrexpressC}`,
      "Content-Type": "application/json",
    };
    let wilaya = String(getWilayaCode(data.state) || "");
    if (wilaya.length === 1) wilaya = "0" + wilaya;
    const postData = {
      keyword: "zrexpress",
      data: {
        Colis: [
          {
            TypeLivraison: data.stopdeskDelivery ? "1" : "0",
            TypeColis: "0",
            Confrimee: "",
            Client: data.name,
            MobileA: data.phone,
            MobileB: data.phone,
            Adresse: adresse,
            IDWilaya: wilaya,
            Commune: getCommuneAscii(data.commune),
            Total: data.total,
            Note: getCombinedOrderNote(data),
            TProduit: `${productDetails}`,
            id_Externe: "01",
            Source: "",
          },
        ],
      },
    };

    axios
      .post(url1, postData, { headers })
      .then((response) => {
        const tracking = response.data?.data?.Colis?.[0]?.Tracking;
        if (tracking != null) {
          updateDoc(doc(db, "orders", data.id), {
            deleveryStatus: "4",
            tracking,
            DC: status,
          }).then(() => {
            if (typeof onSuccess === "function") {
              try {
                onSuccess({
                  ...data,
                  deleveryStatus: "4",
                  tracking,
                  DC: status,
                });
              } catch (e) {
                console.error("onSuccess callback error:", e);
              }
            }
          });
        }
      })
      .catch((error) => {
        setErrorMessage(getUploadLivraisonErrorMessage(error) || (error.data?.data || "Une erreur est survenue"));
      });
  } else if (status === "4") {
    if (isStopdeskEnabled(data)) {
      const deskCode = selectedDeskCode || noestSelectedDeskCode;
      if (deskCode) {
        const result = await sendToNoestWithDesk({
          data,
          productDetails,
          adresse,
          selectedDeskCode: deskCode,
          store,
          deliveryCompanyStatus: status,
          onSuccess,
        });
        if (!result?.success && result?.error) {
          setErrorMessage(result.error);
        }
        return result;
      }

      return new Promise((resolve, reject) => {
        setNoestPendingData(data);
        setNoestPendingResolve(() => resolve);
        setNoestPendingReject(() => reject);
        setNoestModalOpen(true);
      });
    }

    const result = await sendToNoestNormal({
      data,
      productDetails,
      adresse,
      store,
      deliveryCompanyStatus: status,
      onSuccess,
    });
    if (!result?.success && result?.error) {
      setErrorMessage(result.error);
    }
    return result;
  } else if (status === "3") {
    const isStopdesk = isStopdeskEnabled(data);
    const wilayaCode = getWilayaCode(data.state);
    const stopdesks = getEcotrackStopdesksForWilaya(wilayaCode, data.state);

    let selectedDesk =
      ecotrackSelectedDeskName && typeof ecotrackSelectedDeskName === "object"
        ? ecotrackSelectedDeskName
        : null;

    const selectedDeskName =
      typeof ecotrackSelectedDeskName === "string"
        ? ecotrackSelectedDeskName.trim()
        : selectedDesk?.name || "";

    if (
      isStopdesk &&
      !selectedDesk &&
      !selectedDeskName &&
      stopdesks.length > 0
    ) {
      const orderCommuneKey = normalizeText(data.commune);
      const autoDesk = stopdesks.find((d) => {
        const deskCommune = normalizeText(d.commune);
        if (!deskCommune) return false;
        if (deskCommune === orderCommuneKey) return true;
        const eco = data_ecotrack.find(
          (c) =>
            String(c.wilaya_id) === String(Number(wilayaCode)) &&
            (normalizeText(c.nom) === deskCommune ||
              normalizeText(c.nom_ar) === deskCommune),
        );
        return (
          eco &&
          (normalizeText(eco.nom_ar) === orderCommuneKey ||
            normalizeText(eco.nom) === orderCommuneKey)
        );
      });
      if (autoDesk) {
        selectedDesk = autoDesk;
      }
    }

    if (
      isStopdesk &&
      stopdesks.length > 0 &&
      !selectedDesk &&
      !selectedDeskName &&
      typeof setEcotrackPendingData === "function" &&
      typeof setEcotrackPendingDesks === "function" &&
      typeof setEcotrackPendingResolve === "function" &&
      typeof setEcotrackPendingReject === "function" &&
      typeof setEcotrackModalOpen === "function"
    ) {
      return new Promise((resolve, reject) => {
        setEcotrackPendingData(data);
        setEcotrackPendingDesks(stopdesks);
        setEcotrackPendingResolve(() => resolve);
        setEcotrackPendingReject(() => reject);
        setEcotrackModalOpen(true);
      });
    }

    const deskFromName =
      selectedDesk ||
      (selectedDeskName
        ? stopdesks.find((d) => d.name === selectedDeskName) || null
        : null);

    const communeName = resolveEcotrackCommune({
      isStopdesk,
      orderCommuneAr: data.commune,
      wilayaCode,
      selectedDesk: deskFromName,
    });

    if (!communeName) {
      setErrorMessage(
        t("orders.datatable_templating_demo.ecotrack_errors.missing_commune"),
      );
      return;
    }

    if (isStopdesk && stopdesks.length > 0 && !deskFromName) {
      setErrorMessage(
        t("orders.datatable_templating_demo.ecotrack_errors.invalid_commune") ||
          "يرجى اختيار مكتب التوقف",
      );
      return;
    }

    const params = new URLSearchParams({
      api_token: store.Ecotrack || "",
      nom_client: data.name || "",
      telephone: data.phone || "",
      telephone_2: data.phone2 || data.phone || "",
      adresse: adresse || ".",
      commune: communeName,
      code_wilaya: String(wilayaCode || ""),
      montant: String(data.total ?? 0),
      remarque: getCombinedOrderNote(data),
      produit: productDetails || "",
      stock: data.stockDelivery ? "1" : "0",
      quantite: String(data.qty ?? 1),
      type: "1",
      stop_desk: isStopdesk ? "1" : "0",
    });

    try {
      const response = await axios.post(
        `${store.Uecotrack}/api/v1/create/order?${params.toString()}`,
      );

      if (response.status === 200 && response.data?.tracking) {
        const tracking = response.data.tracking;
        const deskLabel = deskFromName?.name || selectedDeskName || null;

        await updateDoc(doc(db, "orders", data.id), {
          DC: status,
          deleveryStatus: "4",
          tracking,
          selectedDesk: isStopdesk ? deskLabel : null,
        });

        if (typeof onSuccess === "function") {
          try {
            onSuccess({
              ...data,
              DC: status,
              deleveryStatus: "4",
              tracking,
              selectedDesk: isStopdesk ? deskLabel : null,
            });
          } catch (e) {
            console.error("onSuccess callback error:", e);
          }
        }
      } else {
        setErrorMessage(
          response.data?.message ||
            t("orders.datatable_templating_demo.ecotrack_errors.default"),
        );
      }
    } catch (error) {
      const apiMessage = error.response?.data?.message;
      setErrorMessage(getEcotrackTranslatedError(apiMessage, t));
    }
  } else if (status === "5") {
    if (isStopdeskEnabled(data)) {
      const deskCode = selectedDeskCode || yalidineSelectedDeskCode;
      if (deskCode) {
        return sendToYalidineWithDesk({
          data,
          productDetails,
          adresse,
          selectedDeskCode: deskCode,
          store,
          deliveryCompanyStatus: status,
          onSuccess,
        });
      }

      return new Promise((resolve, reject) => {
        setYalidinePendingData(data);
        setYalidinePendingResolve(() => resolve);
        setYalidinePendingReject(() => reject);
        setYalidineModalOpen(true);
      });
    }

    return sendToYalidineNormal({
      data,
      productDetails,
      adresse,
      store,
      deliveryCompanyStatus: status,
      onSuccess,
    });
  } else if (status === "6") {
    const dataGuepex = data_guepex.filter((d) => d.name_ar === data.commune);
    if (!dataGuepex[0]) {
      setErrorMessage("Commune introuvable pour Guepex");
      return;
    }
    // suppressed debug log
    const commune = dataGuepex[0]?.name;
    const willaya = dataGuepex[0]?.wilaya_name;
    const postData = [
      {
        order_id: "MyFirstOrder",
        from_wilaya_name: `${store.ApitokenGW}`,
        firstname: ".",
        familyname: data.name,
        contact_phone: data.phone,
        address: adresse,
        to_commune_name: commune,
        to_wilaya_name: willaya,
        product_list: `${productDetails}`,
        price: totalNumber,
        do_insurance: false,
        declared_value: totalNumber,
        length: 10,
        width: 10,
        height: 10,
        weight: 1,
        freeshipping: true,
        is_stopdesk: data.stopdeskDelivery ? data.stopdeskDelivery : false,
        has_exchange: false,
        product_to_collect: null,
        economic: store.guepexeconomic,
      },
    ];
    console.log("postData", JSON.stringify(postData, null, 2));
    console.log("headers", {
      "gupex-id": store.UserguidGuepex,
      "gupex-token": store.Apitokenguepex,
    });
    axios
      .post(
        url1,
        {
          keyword: "gupex",
          data: postData,
        },
        {
          headers: {
            "gupex-id": store.UserguidGuepex,
            "gupex-token": store.Apitokenguepex,
            "Content-Type": "application/json",
          },
        },
      )
      .then((response) => {
        const tracking = response.data?.data?.MyFirstOrder.tracking;
        updateDoc(doc(db, "orders", data.id), {
          deleveryStatus: "4",
          tracking,
          DC: status,
        }).then(() => {
          if (typeof onSuccess === "function") {
            try {
              onSuccess({
                ...data,
                deleveryStatus: "4",
                tracking,
                DC: status,
              });
            } catch (e) {
              console.error("onSuccess callback error:", e);
            }
          }
        });
      })
      .catch((error) => {
        console.error(
          "UploadLivraison error:",
          error.response?.data || error.message,
        );
        setErrorMessage(
          getUploadLivraisonErrorMessage(error) || (error.response?.statusText || "Une erreur est survenue"),
        );
      });
  } else if (status === "7") {
    axios
      .post(
        `https://api.elogistia.com/insertCommande/?apiKey=${store.apielogistia}&name=${data.name}&firstname=a&mail=foorwebs@gmail.com&phone=${data.phone}&address=${adresse}&commune=${getCommuneAscii(data.commune)}&fraisDeLivraison=0&remarque=${getCombinedOrderNote(data)}&stop_desk=${data.stopdeskDelivery ? 2 : 1}&wilaya=${getWilayaCode(data.state)}&product=${productDetails}&price=${data.total}&modeDeLivraison=1&exchangeName=&IdCommande=1052847`,
      )
      .then((response) => {
        if (response.status === 200) {
          updateDoc(doc(db, "orders", data.id), {
            deleveryStatus: "4",
            tracking: data.id,
            DC: status,
          }).then(() => {
            if (typeof onSuccess === "function") {
              try {
                onSuccess({
                  ...data,
                  deleveryStatus: "4",
                  tracking: data.id,
                  DC: status,
                });
              } catch (e) {}
            }
          });
        }
      })
      .catch((error) => {
        setErrorMessage(
          getUploadLivraisonErrorMessage(error) || (error.response?.data?.Message || "Une erreur est survenue"),
        );
      });
  } else if (status === "8") {
    const datatCommune = getDatatCommune(data.commune);
    const communeZimou =
      CommuneZimou.find((c) => c.id === datatCommune?.pk)?.id ||
      CommuneZimou.find((c) => c.id === datatCommune?.id)?.id;

    const postData = {
      name: data.nameproduct,
      client_last_name: ".",
      client_first_name: data.name,
      client_phone: data.phone,
      address: adresse,
      commune: communeZimou,
      wilaya: parseInt(getWilayaCode(data.state) || "", 10),
      order_id: data.id,
      weight: 1,
      delivery_type: "Flexible",
      price: parseInt(data.total, 10),
      free_delivery: true,
      observation: getCombinedOrderNote(data),
      type: "ecommerce",
    };

    axios
      .post(`${store.zimouUrl}/api/v1/packages`, postData, {
        headers: {
          Authorization: `Bearer ${store.zimouToken}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        const tracking = response.data?.data?.tracking_code;
        if (tracking) {
          updateDoc(doc(db, "orders", data.id), {
            deleveryStatus: "4",
            tracking,
            DC: status,
          });
          Swal.fire({
            icon: "success",
            title: t("ui.orderSent"),
            text: t("ui.checkZimou"),
            confirmButtonText: t("orders.datatable_templating_demo.okay"),
            confirmButtonColor: "#7e5395",
            timer: 3000,
            timerProgressBar: true,
            position: "bottom-end",
            toast: true,
            showConfirmButton: false,
          });
        } else {
          setErrorMessage(t("ui.zimouNoTracking"));
        }
      })
      .catch((error) => {
        setErrorMessage(
          getUploadLivraisonErrorMessage(error) || (error.response?.data?.message || "حدث خطأ أثناء إرسال الطلب"),
        );
      });
  } else if (status === "9") {
    const CiteMorooco = citeMorooco.find((d) => d.name === data.state);
    const formData = new FormData();
    formData.append("type", "SIMPLE");
    formData.append("business", store.AmeexId);
    formData.append("order_num", "ORDER_NUM_1");
    formData.append("replace", "true");
    formData.append("exchange_code", "");
    formData.append("open", "NO");
    formData.append("try", "YES");
    formData.append("fragile", "0");
    formData.append("receiver", data.name);
    formData.append("phone", data.phone);
    formData.append("city", CiteMorooco?.id);
    formData.append("address", adresse);
    formData.append("comment", getCombinedOrderNote(data));
    formData.append("product", data.productName || "منتج من المتجر");
    formData.append("cod", parseInt(data.total, 10));
    formData.append("products[0][id]", data.productId || "");
    formData.append("products[0][qty]", "1");

    axios
      .post(
        "https://api.ameex.app/customer/Delivery/Parcels/Action/Type/Add",
        formData,
        {
          headers: {
            "C-Api-Id": `${store.AmeexId}`,
            "C-Api-Key": `${store.AmeexKey}`,
            "Content-Type": "multipart/form-data",
          },
        },
      )
      .then((response) => {
        const resApi = response.data?.api;

        if (resApi?.type === "success" && resApi?.data?.id) {
          const tracking = resApi.data.id;
          const trackingCode = resApi.data.code;

          updateDoc(doc(db, "orders", data.id), {
            deleveryStatus: "4",
            tracking,
            trackingCode,
            DC: status,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: t("ship.error"),
            text: t("ui.ameexNoTracking"),
            confirmButtonText: t("orders.datatable_templating_demo.okay"),
            confirmButtonColor: "#7e5395",
          });
        }
      })
      .catch(() => {
        Swal.fire({
          icon: "error",
          title: t("ui.sendOrderFailed"),
          text: t("ui.checkConnectionAccount"),
          confirmButtonText: t("orders.datatable_templating_demo.okay"),
          confirmButtonColor: "#7e5395",
        });
      });
  } else if (status === "10") {
    const states = states_lby.list;
    const state = states.find((s) => s.name === data.state);
    const stateId = state ? state.id : null;
    const url = `https://api.mdm.express/api/geo/countries/LBY/states/${stateId}/cities?perPage=1500`;

    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${store.mdm_apikey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        const city = response.data.list.find((c) => c.name === data.commune);
        const cityId = city?.id || "LBY004";
        const sku = products.find((p) => p.name === data.products[0].name)?.sku;
        const postData = {
          client: {
            firstName: ".",
            lastName: data.name,
            phone: data.phone,
            phone2: data.phone2,
          },
          confirmed: false,
          confirmedByUs: true,
          declaredValue: Number(totalNumber) || 0,
          destination: {
            cityId,
            streetAddress: adresse,
          },
          fragile: false,
          freeShipping: store?.delevery?.free || false,
          height: 0,
          isInsuranceEnabled: false,
          isStopDesk: data.stopdeskDelivery || false,
          length: 0,
          liquid: false,
          notes: getCombinedOrderNote(data),
          openable: false,
          paymentMethod: "cash",
          products: [
            {
              _price: 10,
              _variantOf: sku,
              quantity: Number(data.qty) || 1,
              trackingId: sku,
            },
          ],
          storeId: `${store.mdm_storeId}`,
          totalPrice: Number(data.total) || 0,
          weight: 0,
          width: 0,
        };

        axios
          .post("https://api.mdm.express/api/v2/orders", postData, {
            headers: {
              Authorization: `Bearer ${store.mdm_apikey}`,
              "Content-Type": "application/json",
            },
          })
          .then((createResponse) => {
            if (createResponse.status === 200) {
              updateDoc(doc(db, "orders", data.id), {
                deleveryStatus: "4",
                tracking: createResponse.data.trackingId,
                DC: status,
              }).then(() => {
                if (typeof onSuccess === "function") {
                  try {
                    onSuccess({
                      ...data,
                      deleveryStatus: "4",
                      tracking: createResponse.data.trackingId,
                      DC: status,
                    });
                  } catch (e) {
                    console.error("onSuccess callback error:", e);
                  }
                }
              });
            } else {
              Swal.fire({
                icon: "error",
                title: t("ship.error"),
                text: t("ui.ameexNoTracking"),
                confirmButtonText: t("orders.datatable_templating_demo.okay"),
                confirmButtonColor: "#7e5395",
              });
            }
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: t("ui.sendOrderFailed"),
              text:
                error.response?.data?.error?.message ||
                t("ui.checkConnectionAccount"),
              confirmButtonText: t("orders.datatable_templating_demo.okay"),
              confirmButtonColor: "#7e5395",
            });
          });
      })
      .catch((error) => {
        setErrorMessage(
          getUploadLivraisonErrorMessage(error) || (error.response?.statusText || "Une erreur est survenue"),
        );
      });
  } else if (status === "11") {
    const postData = {
      order_id: "MyFirstOrder",
      from_wilaya_name: store.YalitecW,
      firstname: data.name,
      familyname: "",
      contact_phone: data.phone,
      address: data.address,
      to_commune_name: getCommuneAscii(data.commune),
      to_wilaya_name: getWilayaAscii(data.state),
      product_list: `${productDetails}`,
      price: data.total,
      do_insurance: false,
      declared_value: data.total,
      Width: 0,
      Height: 0,
      length: 0,
      Weight: 0,
      freeshipping: data.deliveryPrice === 0,
      is_stopdesk: data.stopdeskDelivery || false,
      stopdesk_id: 0,
      has_exchange: false,
      product_to_collect: null,
    };

    try {
      const response = await fetch(
        "https://backend.foorweb.store/api/SendOrdersYalitec",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            apiId: `${store.YalitecId}`,
            apiToken: `${store.YalitecToken}`,
            parcels: [postData],
          }),
        },
      );

      const result = await response.json();

      if (!response.ok) {
        console.error("Erreur Yalitec :", result);
      } else {
        const tracking = result?.MyFirstOrder.tracking;

        await updateDoc(doc(db, "orders", data.id), {
          deleveryStatus: "4",
          tracking,
          DC: status,
        });

        if (typeof onSuccess === "function") {
          try {
            onSuccess({
              ...data,
              deleveryStatus: "4",
              tracking,
              DC: status,
            });
          } catch (e) {
            console.error("onSuccess callback error:", e);
          }
        }
      }
    } catch (error) {
      console.error("Erreur lors de la requête à l’API locale :", error);
    }
  } else if (status === "12") {
    const postData = {
      client_name: data.name,
      wilaya_name: data.state,
      order_note: getCombinedOrderNote(data),
      phone_st: data.phone,
      phone_sc: data.phone2 || "",
      order_adress: data.address,
      commune_name: data.commune,
      product_name: productDetails,
      qte: 1,
      product_price: `${data.total}`,
      wilaya_mat: null,
      commune_postal: null,
      stopdesk_status: data.stopdeskDelivery || false,
      order_ref: data.id,
      order_brittle: false,
      order_exchange: false,
      order_refund: false,
      sku: null,
    };

    try {
      const response = await fetch(
        "https://api.colivraison.express/v2/orders/bulk",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${store.coliv_token}`,
            "coliv-public-key": `${store.coliv_pubKey}`,
            accept: "application/json",
          },
          body: JSON.stringify({
            orders: [postData],
          }),
        },
      );

      const result = await response.json();

      if (!response.ok) {
        console.error("Erreur Colivraison :", result);
      } else {
        const messageKey = Object.keys(result.messages)[0];
        const tracking = result.messages[messageKey].tracking;
        await updateDoc(doc(db, "orders", data.id), {
          deleveryStatus: "4",
          tracking,
          DC: status,
        });

        if (typeof onSuccess === "function") {
          try {
            onSuccess({
              ...data,
              deleveryStatus: "4",
              tracking,
              DC: status,
            });
          } catch (e) {
            console.error("onSuccess callback error:", e);
          }
        }
      }
    } catch (error) {
      console.error("Erreur lors de l’appel à l’API Colivraison :", error);
    }
  } else if (status === "13") {
    const wilayaMylrz = wilayaMylerzzz.Value.find(
      (d) => d.ArName === data.state,
    )?.Zones[0].Code;
    const mylerzOrderPayload = [
      {
        Package_Serial: data.index,
        Description: data.products?.[0]?.name || "Colis",
        Service_Type: data.stopdeskDelivery ? "CTC" : "CTD",
        PAYMENT_TYPE: "COD",
        Service: "ND",
        Service_Category: "DELIVERY",
        Street: data.address || "",
        Neighborhood: wilayaMylrz,
        COD_Value: parseFloat(data.total),
        Pieces: [
          {
            pieceNo: data.index,
            SpecialNotes: getCombinedOrderNote(data),
          },
        ],
        Customer_Name: data.name,
        Mobile_No: data.phone,
        PickupDueDate: new Date().toISOString(),
      },
    ];

    try {
      const response = await fetch(
        "https://backend.foorweb.shop/api/mylerz/AddOrderMylerz",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${store.mylerzToken}`,
            Accept: "application/json",
          },
          body: JSON.stringify(mylerzOrderPayload),
        },
      );

      const result = await response.json();

      if (result.IsErrorState) {
        setErrorMessage(
          result.Value?.ErrorCode || "فشل في إرسال الطلب إلى Mylerz",
        );
      } else {
        const tracking = result?.Value?.Packages?.[0]?.BarCode || null;

        await updateDoc(doc(db, "orders", data.id), {
          deleveryStatus: "4",
          tracking,
          DC: status,
        });

        if (typeof onSuccess === "function") {
          try {
            onSuccess({
              ...data,
              deleveryStatus: "4",
              tracking,
              DC: status,
            });
          } catch (e) {
            console.error("onSuccess callback error:", e);
          }
        }

        Swal.fire({
          icon: "success",
          title: t("ui.mylerzOrderSent"),
          text: t("ui.checkMylerz"),
          confirmButtonText: t("orders.datatable_templating_demo.okay"),
          confirmButtonColor: "#7e5395",
          timer: 3000,
          timerProgressBar: true,
          position: "bottom-end",
          toast: true,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      setErrorMessage(getUploadLivraisonErrorMessage(error) || (error.message || "حدث خطأ غير متوقع"));
    }
  } else if (status === "14") {
    const stopdesk = isStopdeskEnabled(data) ? 1 : 0;
    // suppressed debug log
    const echange =
      data.exchangeDelivery != null && data.exchangeDelivery ? 1 : 0;

    let total = data.total;
    if (data.deleveryPrice) {
      total += data.deleveryPrice;
    }
    const wilayaCode = getWilayaCode(data.state);

    const commune = data_ecom.find(
      (d) => d.Commune_ar === data.commune && d.Wilaya == wilayaCode,
    )?.Commune;

    // Gestion du stopdesk - filtrer et afficher modal si nécessaire
    if (stopdesk === 1) {
      const deskCode = ecomdeliverySelectedDeskCode || selectedDeskCode;

      if (deskCode) {
        // Si un stopdesk est déjà sélectionné
        const postData = {
          Colis: [
            {
              Echange: echange,
              Stopdesk: stopdesk,
              NomComplet: data.name,
              Mobile_1: data.phone,
              Mobile_2: data.phone2 || "",
              Adresse: adresse,
              Wilaya: wilayaCode,
              Commune: commune,
              Article: productDetails,
              Ref_Article: data.products?.[0]?.sku || productDetails,
              NoteFournisseur: getCombinedOrderNote(data),
              Total: total.toString(),
              ID_Externe: data.id,
              Source: "Foorweb",
              CodeStopdesk: deskCode,
            },
          ],
        };
        // suppressed debug log

        try {
          const response = await axios.post(
            "https://backend.foorweb.shop/api/ecomdelivery/new-order",
            postData,
            {
              headers: {
                Key: store.ecomdelivery_key,
                Token: store.ecomdelivery_token,
                "Content-Type": "application/json",
              },
            },
          );

          const tracking = response.data.tracking;
          if (tracking) {
            await updateDoc(doc(db, "orders", data.id), {
              deleveryStatus: "4",
              tracking,
              DC: status,
            });

            if (typeof onSuccess === "function") {
              try {
                onSuccess({
                  ...data,
                  deleveryStatus: "4",
                  tracking,
                  DC: status,
                });
              } catch (e) {
                console.error("onSuccess callback error:", e);
              }
            }
          } else {
            const message =
              response.data.Colis[0].Message ||
              "Erreur lors de la création de la commande !";
            setErrorMessage(message);
          }
        } catch (error) {
          setErrorMessage(
            getUploadLivraisonErrorMessage(error) || (error.response?.data?.error ||
              error.response?.data?.message ||
              "Une erreur est survenue"),
          );
        }
      } else {
        // Ouvrir le modal pour sélectionner un stopdesk
        return new Promise((resolve, reject) => {
          setEcomdeliveryPendingData(data);
          setEcomdeliveryPendingResolve(() => resolve);
          setEcomdeliveryPendingReject(() => reject);
          setEcomdeliveryModalOpen(true);
        });
      }
    } else {
      // Sans stopdesk, envoyer directement
      const postData = {
        Colis: [
          {
            Echange: echange,
            Stopdesk: stopdesk,
            NomComplet: data.name,
            Mobile_1: data.phone,
            Mobile_2: data.phone2 || "",
            Adresse: adresse,
            Wilaya: wilayaCode,
            Commune: commune,
            Article: productDetails,
            Ref_Article: data.products?.[0]?.sku || productDetails,
            NoteFournisseur: getCombinedOrderNote(data),
            Total: total.toString(),
            ID_Externe: data.id,
            Source: "Foorweb",
          },
        ],
      };
      // suppressed debug log

      try {
        const response = await axios.post(
          "https://backend.foorweb.shop/api/ecomdelivery/new-order",
          postData,
          {
            headers: {
              Key: store.ecomdelivery_key,
              Token: store.ecomdelivery_token,
              "Content-Type": "application/json",
            },
          },
        );

        const tracking = response.data.tracking;
        if (tracking) {
          await updateDoc(doc(db, "orders", data.id), {
            deleveryStatus: "4",
            tracking,
            DC: status,
          });

          if (typeof onSuccess === "function") {
            try {
              onSuccess({
                ...data,
                deleveryStatus: "4",
                tracking,
                DC: status,
              });
            } catch (e) {
              console.error("onSuccess callback error:", e);
            }
          }
        } else {
          const message =
            response.data.Colis[0].Message ||
            "Erreur lors de la création de la commande !";
          setErrorMessage(message);
        }
      } catch (error) {
        setErrorMessage(
          getUploadLivraisonErrorMessage(error) || (error.response?.data?.error ||
            error.response?.data?.message ||
            "Une erreur est survenue"),
        );
      }
    }
  } else if (status === "15") {
    const stopdesk =
      data.stopdeskDelivery != null && data.stopdeskDelivery ? 1 : 0;
    const echange =
      data.exchangeDelivery != null && data.exchangeDelivery ? 1 : 0;

    let total = data.total;
    if (data.deleveryPrice) {
      total += data.deleveryPrice;
    }

    const wilayaCode = getWilayaCode(data.state) || "";

    const postData = {
      Colis: [
        {
          Echange: echange,
          Stopdesk: stopdesk,
          NomComplet: data.name,
          Mobile_1: data.phone,
          Mobile_2: data.phone2 || "",
          Adresse: adresse,
          Wilaya: wilayaCode,
          Commune: data.commune,
          Article: productDetails,
          Ref_Article: data.products?.[0]?.sku || productDetails,
          NoteFournisseur: getCombinedOrderNote(data),
          Total: total,
          ID_Externe: data.id,
          Source: "Foorweb",
        },
      ],
    };

    try {
      const response = await axios.post(
        "https://backend.foorweb.store/api/v1/flashdelivery/addcolis",
        {
          key: store.flashdelivery_key,
          token: store.flashdelivery_token,
          colis: postData.Colis,
        },
      );

      const colisResponse = response.data.Colis?.[0];
      if (colisResponse?.Tracking) {
        await updateDoc(doc(db, "orders", data.id), {
          deleveryStatus: "4",
          tracking: colisResponse.Tracking,
          DC: status,
        });

        if (typeof onSuccess === "function") {
          try {
            onSuccess({
              ...data,
              deleveryStatus: "4",
              tracking: colisResponse.Tracking,
              DC: status,
            });
          } catch (e) {
            console.error("onSuccess callback error:", e);
          }
        }
      } else {
        const message =
          response.data.error ||
          "Erreur lors de la création de la commande Flash !";
        setErrorMessage(message);
      }
    } catch (error) {
      setErrorMessage(
        getUploadLivraisonErrorMessage(error) || (error.response?.data?.error ||
          error.response?.data?.message ||
          error.message ||
          "Une erreur inconnue est survenue lors de l'appel à Flash Delivery"),
      );
    }
  } else if (status === "18") {
    // Re-lire la commande depuis Firestore juste avant l'envoi : si l'utilisateur
    // vient de modifier l'adresse/wilaya/commune, `data` (prop de la ligne du tableau,
    // ou état Redux) peut ne pas encore refléter cette modification. On construit donc
    // le colis à partir de la version la plus fraîche possible du document.
    let orderData = data;
    try {
      const freshSnap = await getDoc(doc(db, "orders", data.id));
      if (freshSnap.exists()) {
        orderData = { ...data, ...freshSnap.data(), id: data.id };
      }
    } catch (error) {
      console.error(
        "Ecom Delivery v2: impossible de relire la commande avant l'envoi:",
        error,
      );
    }

    const freshAdresse = orderData.address ? orderData.address : ".";
    const freshProductDetails = buildProductDetails(orderData);

    const totalNumber = Number(orderData.total) || 0;
    const livraisonFee =
      Number(orderData.deleveryPrice || orderData.deliveryPrice || 0) || 0;
    const total = totalNumber + livraisonFee;

    const idWilaya = Number(getWilayaCode(orderData.state) || 0);
    const quantite = Number(orderData.qty) || 1;
    const article =
      freshProductDetails ||
      orderData.products?.[0]?.name ||
      orderData.nameproduct ||
      "";
    const stopdesk = isStopdeskEnabled(orderData) ? 1 : 0;

    if (!idWilaya) {
      setErrorMessage(t("ui.ecomStateRequired"));
      return;
    }

    const buildColis = (codeStopdesk) => {
      const colis = {
        nom_complet: orderData.name || "",
        mobile_1: orderData.phone || "",
        id_wilaya: idWilaya,
        article,
        //if the client enable the stock delivery, we will send the sku of the first product as ref_article with a fallback into an empty string to evoid sending undefined or null values to the API
        ref_article:
          orderData.stockDelivery === true
            ? orderData.products?.[0]?.sku || ""
            : "",
        quantite,
        total,
        adresse: freshAdresse && freshAdresse !== "." ? freshAdresse : "",
        note_fournisseur: getCombinedOrderNote(orderData),
        id_externe: orderData.id || "",
        stopdesk,
        // Already confirmed with the customer on our side (status 3 = مؤكدة,
        // 9 = مؤكدة من قبل العميل) — skip Ecom's own "En Préparation" step.
        confirmee:
          orderData.deleveryStatus === "3" || orderData.deleveryStatus === "9"
            ? 1
            : 0,
        // Status 21 is this codebase's exchange order status (see
        // FoorcallStats.js's status === "21" -> "exchange").
        echange: orderData.deleveryStatus === "21" ? 1 : 0,
      };

      if (stopdesk === 1) {
        colis.code_stopdesk = codeStopdesk || "";
      } else {
        const communeMatch = data_ecom.find(
          (d) => d.Commune_ar === orderData.commune && d.Wilaya === idWilaya,
        );
        colis.commune = communeMatch?.Commune || orderData.commune || "";
      }

      return [colis];
    };

    const submitEcomDeliveryV2 = async (codeStopdesk) => {
      try {
        const response = await axios.post(
          "https://ecom-dz.com/api_v2/colis",
          buildColis(codeStopdesk),
          {
            headers: {
              "X-API-Key": `${store.ecomdeliveryv2_key || ""}`,
              "X-API-Token": `${store.ecomdeliveryv2_token || ""}`,
              "Content-Type": "application/json",
            },
          },
        );

        const result = response?.data?.resultats?.[0];
        const tracking = result?.tracking || null;

        if (tracking) {
          await updateDoc(doc(db, "orders", data.id), {
            deleveryStatus: "4",
            tracking,
            DC: status,
          });

          if (typeof onSuccess === "function") {
            try {
              onSuccess({
                ...orderData,
                deleveryStatus: "4",
                tracking,
                DC: status,
              });
            } catch (e) {
              console.error("onSuccess callback error:", e);
            }
          }
        } else {
          const apiErrorMessage =
            result?.erreur ||
            response?.data?.error?.message ||
            response?.data?.message ||
            "Erreur lors de la création de la commande Ecom Delivery V2 !";
          setErrorMessage(apiErrorMessage);
        }
      } catch (error) {
        const apiErrorMessage =
          error?.response?.data?.error?.message ||
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          error?.message ||
          "Une erreur inconnue est survenue lors de l'appel à Ecom Delivery API V2";
        setErrorMessage(apiErrorMessage);
      }
    };

    if (stopdesk === 1) {
      const deskCode = ecomdeliveryV2SelectedDeskCode;

      if (deskCode) {
        await submitEcomDeliveryV2(deskCode);
      } else if (typeof setEcomdeliveryV2ModalOpen === "function") {
        return new Promise((resolve, reject) => {
          setEcomdeliveryV2PendingData(orderData);
          setEcomdeliveryV2PendingResolve(() => resolve);
          setEcomdeliveryV2PendingReject(() => reject);
          setEcomdeliveryV2ModalOpen(true);
        });
      } else {
        setErrorMessage(t("ui.ecomStopdeskRequired"));
      }
    } else {
      await submitEcomDeliveryV2(null);
    }
  } else if (status === "16") {
    try {
      const isPickupPoint = isStopdeskEnabled(data);
      const selectedHub =
        zrExpressSelectedHub && typeof zrExpressSelectedHub === "object"
          ? zrExpressSelectedHub
          : null;
      const selectedHubId =
        typeof zrExpressSelectedHub === "string"
          ? zrExpressSelectedHub
          : selectedHub?.id || "";

      if (isPickupPoint && !selectedHubId) {
        if (
          typeof setZrExpressPendingData === "function" &&
          typeof setZrExpressPendingResolve === "function" &&
          typeof setZrExpressPendingReject === "function" &&
          typeof setZrExpressModalOpen === "function"
        ) {
          return new Promise((resolve, reject) => {
            setZrExpressPendingData(data);
            setZrExpressPendingResolve(() => resolve);
            setZrExpressPendingReject(() => reject);
            setZrExpressModalOpen(true);
          });
        }

        const noHubMessage = "يرجى اختيار pickup point قبل إرسال الطلب";
        if (typeof setErrorMessage === "function") {
          setErrorMessage(noHubMessage);
        }

        return {
          success: false,
          message: noHubMessage,
          requiresHubSelection: true,
        };
      }

      const wilayaFr = datatZr.find(
        (w) => w.wilaya_name === data.state,
      )?.wilaya_name_ascii;
      const communeFr = datatZr.find(
        (c) => c.commune_name === data.commune,
      )?.commune_name_ascii;

      if (!wilayaFr || !communeFr) {
        throw new Error("ولاية أو بلدية غير معروفة");
      }

      const cityTerritory = territoriesData.items.find(
        (territory) =>
          territory.level === "wilaya" && territory.name === wilayaFr,
      );
      const districtTerritory = territoriesData.items.find(
        (territory) =>
          territory.level === "commune" &&
          territory.name === communeFr &&
          territory.parentId === cityTerritory?.id,
      );

      if (!cityTerritory || !districtTerritory) {
        throw new Error("Territory IDs غير موجودة");
      }

      const selectedHubAddress = selectedHub?.address || {};
      const deliveryCity =
        isPickupPoint && selectedHubAddress?.city
          ? selectedHubAddress.city
          : wilayaFr;
      const deliveryDistrict =
        isPickupPoint && selectedHubAddress?.district
          ? selectedHubAddress.district
          : communeFr;
      const deliveryStreet =
        isPickupPoint && selectedHubAddress?.street
          ? selectedHubAddress.street
          : data.address;
      const deliveryCityTerritoryId =
        isPickupPoint && isValidGuid(selectedHubAddress?.cityTerritoryId)
          ? selectedHubAddress.cityTerritoryId
          : cityTerritory.id;
      const deliveryDistrictTerritoryId =
        isPickupPoint && isValidGuid(selectedHubAddress?.districtTerritoryId)
          ? selectedHubAddress.districtTerritoryId
          : districtTerritory.id;

      const orderedProducts = [];
      for (const item of data.products) {
        const productData = products.find((prod) => prod.sku === item.sku);
        let productIdZr = productData?.zrExpressId;
        const sku = productData?.sku;
        const qty = productData?.qty;

        if (!productIdZr) {
          const productRes = await axios.post(
            "https://backend.foorweb.shop/api/zrexpress/create-product",
            {
              name: String(item.name || "")
                .replace(/\|/g, " - ")
                .trim(),
              sku: sku,
              basePrice: item?.price,
              localStock: qty,
              length: item.length || 0,
              width: item.width || 0,
              height: item.height || 0,
              weight: item.weight || 0,
              zrExpressXTenant_V2: store.zrExpressXTenant_V2,
              zrExpressApiKey_V2: store.zrExpressApiKey_V2,
            },
          );
          productIdZr = productRes.data.productIdZr;

          const productRef = doc(db, "products", productData.id);
          await updateDoc(productRef, { zrExpressId: productIdZr });
        }

        orderedProducts.push({
          unitPrice: Number(item.price),
          quantity: Number(item.quantity),
          productId: productIdZr,
          productName: String(item.name || "")
            .replace(/\|/g, " - ")
            .trim(),
          ProductSku: sku,
          length: item.length || 0,
          width: item.width || 0,
          height: item.height || 0,
          weight: item.weight || 0,
          stockType: "local",
        });
      }

      const formatPhoneNumber = (phone) => {
        if (!phone) return "";

        let cleaned = String(phone).replace(/\D/g, "");

        if (cleaned.startsWith("0")) {
          cleaned = "213" + cleaned.substring(1);
        }

        if (cleaned.length === 9) {
          cleaned = "213" + cleaned;
        }

        if (cleaned.startsWith("213")) {
          return `+${cleaned}`;
        }

        return `+${cleaned}`;
      };

      const postData = {
        customer: {
          name: String(data.name || "").trim(),
          phone: {
            number1: formatPhoneNumber(data.phone),
            ...(data.phone2 ? { number2: formatPhoneNumber(data.phone2) } : {}),
            ...(data.phone3 ? { number3: formatPhoneNumber(data.phone3) } : {}),
          },
          email: "tadjer@foorweb.store",
        },
        deliveryAddress: {
          street: String(deliveryStreet || "").trim(),
          city: String(deliveryCity || "").trim(),
          district: String(deliveryDistrict || "").trim(),
          postalCode: data.postalCode || "",
          country: "algeria",
          cityTerritoryId: deliveryCityTerritoryId,
          districtTerritoryId: deliveryDistrictTerritoryId,
        },
        orderedProducts,
        amount: Number(data.total) + Number(data.deleveryPrice || 0),
        description:
          data.options || orderedProducts.map((p) => p.productName).join(", "),
        deliveryType: isPickupPoint ? "pickup-point" : "home",
        externalId: data.id,
        ...(isPickupPoint && selectedHubId
          ? {
              hubId: selectedHubId,
            }
          : {}),
        ...(isPickupPoint && selectedHubId
          ? {
              pickupPointHubId: selectedHubId,
            }
          : {}),
      };

      if (!/^\+[1-9]\d{7,14}$/.test(postData.customer.phone.number1)) {
        throw new Error("رقم الهاتف الأساسي يجب أن يكون بصيغة دولية صحيحة");
      }

      const zrRequestData = {
        ...postData,
        zrExpressXTenant_V2: store.zrExpressXTenant_V2,
        zrExpressApiKey_V2: store.zrExpressApiKey_V2,
      };

      const response = await axios.post(
        "https://backend.foorweb.shop/api/zrexpress/create-order",
        {
          // `data` is the canonical property used by the ZR proxy.
          data: zrRequestData,
          // Keep the old property temporarily for backward-compatible proxies.
          postData,
          zrExpressXTenant_V2: store.zrExpressXTenant_V2,
          zrExpressApiKey_V2: store.zrExpressApiKey_V2,
        },
      );

      await updateDoc(doc(db, "orders", data.id), {
        deleveryStatus: "4",
        DC: status,
        tracking: response.data.id,
        selectedPickupHub: isPickupPoint
          ? selectedHub || { id: selectedHubId }
          : null,
      });

      if (typeof onSuccess === "function") {
        try {
          onSuccess({
            ...data,
            deleveryStatus: "4",
            DC: status,
            tracking: response.data.id,
            selectedPickupHub: isPickupPoint
              ? selectedHub || { id: selectedHubId }
              : null,
          });
        } catch (e) {
          console.error("onSuccess callback error:", e);
        }
      }

      return {
        success: true,
        message: "تم إرسال الطلب بنجاح إلى ZR Express",
        data: response.data,
      };
    } catch (error) {
      const errorResponse = error.response?.data;

      if (errorResponse?.error?.title === "ParcelErrors.DuplicateExternalId") {
        await updateDoc(doc(db, "orders", data.id), {
          deleveryStatus: "16",
          DC: status,
          sentToZrExpress: true,
          duplicateDetected: true,
          sentAt: new Date().toISOString(),
        });

        if (typeof onSuccess === "function") {
          try {
            onSuccess({
              ...data,
              deleveryStatus: "16",
              DC: status,
              sentToZrExpress: true,
              duplicateDetected: true,
              sentAt: new Date().toISOString(),
            });
          } catch (e) {
            console.error("onSuccess callback error:", e);
          }
        }

        return {
          success: true,
          message: "الطلب موجود مسبقاً في ZR Express وتم تحديث الحالة",
          warning: errorResponse.error.detail,
          duplicate: true,
        };
      }

      const errorMessages = getZrErrorMessages(errorResponse, error.message);
      const errorMessage = errorMessages.join("\n");
      const errorList = errorMessages
        .map(
          (message) => `<li style="margin: 6px 0;">${escapeHtml(message)}</li>`,
        )
        .join("");

      Swal.fire({
        icon: "error",
        title: t("ui.sendOrderFailed"),
        html: `
        <div style="text-align: right; direction: rtl;">
          <p><strong>المشكل:</strong></p>
          <ul style="color: #d33; background: #fee; padding: 10px 30px 10px 10px; border-radius: 5px; margin: 10px 0; text-align: right;">
            ${errorList}
          </ul>
          ${errorResponse?.error?.status ? `<p><small>رمز الخطأ: ${errorResponse.error.status}</small></p>` : ""}
        </div>
      `,
        confirmButtonText: t("ship.ok"),
        confirmButtonColor: "#9e68ba",
      });

      return {
        success: false,
        message: "فشل إرسال الطلب إلى ZR Express",
        error: errorMessage,
        details: errorResponse?.error || null,
      };
    }
  } else if (status === "19") {
    try {
      const provinces = await getOsenProvinces(store.OsenSandbox);

      const province = provinces.find((p) => p.name_arabic === data.state);

      const municipality = province?.municipalities?.find(
        (m) => m.name_arabic === data.commune,
      );
      const municipalityId = municipality?.id;

      if (!municipality?.id) {
        setErrorMessage(
          t("ui.osenCommuneMissing", {
            value0: data.commune,
            value1: data.state,
          }),
        );
        return { success: false };
      }

      const payload = {
        target: {
          fullName: data.name,
          phoneNumberPrimary: String(data.phone),
          municipality: {
            id: municipalityId,
          },
        },
        parcel: {
          description: productDetails || data.nameproduct || "Order",
          weight: 1,
        },
        operation: {
          deliveryType: isStopdeskEnabled(data) ? "STOPDESK" : "DOORSTEP",
        },
        cashCollection: {
          totalPostTarget: Number(data.total) || 0,
        },
      };

      const result = await createOsenOrder(store, payload);

      console.log(result);

      const updatedOrder = {
        ...data,
        deleveryStatus: "4",
        DC: status, // "19"
        tracking: result.trackingId,
        osenOrderId: result.id,
        osenTrackingId: result.trackingId,
      };

      await setDoc(doc(db, "orders", data.id), updatedOrder);

      if (typeof onSuccess === "function") {
        onSuccess(updatedOrder);
      }

      return { success: true, tracking: result.trackingId };
    } catch (error) {
      console.error("OSEN error:", error);
      setErrorMessage(
        error?.response?.data?.message ||
          error?.message ||
          "فشل إرسال الطلب إلى OSEN",
      );
      return { success: false };
    }
  } else {
    await updateDoc(doc(db, "orders", data.id), {
      deleveryStatus: "4",
      DC: status,
    });

    if (typeof onSuccess === "function") {
      try {
        onSuccess({
          ...data,
          deleveryStatus: "4",
          DC: status,
        });
      } catch (e) {
        console.error("onSuccess callback error:", e);
      }
    }
  }

  return null;
}
